import MUIListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useState } from "react";

import { Comment } from "./Comment";
import { CommentInfo } from "./CommentInfo";

function CommentItem({
	comment,
	allowReply,
	onRemoveComment,
	onAddComment,
	onToggleLike,
}) {
	const [isReply, setIsReply] = useState(false);

	return (
		<div key={comment.id}>
			<MUIListItem className="p-0">
				<ListItemText
					className="flex flex-col gap-8"
					disableTypography
					primary={
						<CommentInfo
							comment={comment}
							isReply={isReply}
							setIsReply={setIsReply}
							allowReply={allowReply}
							onRemoveComment={onRemoveComment}
							onToggleLike={onToggleLike}
						/>
					}
					secondary={
						<Comment
							comment={comment}
							isReply={isReply}
							setIsReply={setIsReply}
							onRemoveComment={onRemoveComment}
							onAddComment={onAddComment}
							onToggleLike={onToggleLike}
						/>
					}
				/>
			</MUIListItem>
		</div>
	);
}

export default CommentItem;
